import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './carousel.css';
import RollingGallery from '../../components/RollingGallery';
import { patientsService } from '../../services/firebaseServices';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
  Box,
  IconButton,
  Collapse,
  Fab
} from '@mui/material';
import {
  Pets as PetsIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Favorite as FavoriteIcon,
  WhatsApp as WhatsAppIcon,
  School as SchoolIcon,
  HealthAndSafety as HealthIcon,
  Star as StarIcon,
  Groups as GroupsIcon,
  Verified as VerifiedIcon,
  FlightTakeoff as FlightIcon,
  Menu as MenuIcon,
  ExpandLess as ExpandLessIcon,
  Home as HomeIcon,
  Info as InfoIcon,
  MedicalServices as MedicalIcon,
  ContactPhone as ContactIcon,
  Instagram as InstagramIcon,
  Storefront as PetshopIcon
} from '@mui/icons-material';

const Nosotros = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [pacientesActivos, setPacientesActivos] = useState([]);
  const [loadingPacientes, setLoadingPacientes] = useState(true);

  // Función para cargar pacientes desde Firebase
  const cargarPacientes = async () => {
    setLoadingPacientes(true);
    try {
      console.log('🔄 Cargando pacientes desde Firebase...');
      const result = await patientsService.getPublicGallery();
      
      if (result.success) {
        // La galería pública ya contiene solo pacientes activos con foto
        const pacientesConFoto = result.data;
        
        // Formatear datos para el componente
        const pacientesFormateados = pacientesConFoto.map(paciente => ({
          nombre: paciente.nombre,
          tipo: `${paciente.especie} - ${paciente.raza}`,
          imagen: paciente.foto,
          historia: paciente.observaciones || `${paciente.nombre} es un${paciente.especie === 'Gato' ? 'a' : ''} ${paciente.especie.toLowerCase()} ${paciente.raza.toLowerCase()} que ha sido atendid${paciente.especie === 'Gato' ? 'a' : 'o'} en nuestra clínica veterinaria a domicilio.`
        }));
        
        setPacientesActivos(pacientesFormateados);
        console.log(`✅ ${pacientesFormateados.length} pacientes activos cargados`);
      } else {
        console.error('❌ Error cargando pacientes:', result.error);
        // En caso de error, usar datos por defecto (vacío)
        setPacientesActivos([]);
      }
    } catch (error) {
      console.error('❌ Error en cargarPacientes:', error);
      setPacientesActivos([]);
    } finally {
      setLoadingPacientes(false);
    }
  };

  useEffect(() => {
    // Cargar pacientes al montar el componente
    cargarPacientes();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    const handleClickOutside = (event) => {
      if (mobileMenuOpen && !event.target.closest('.mobile-menu')) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  const misionVision = [
    {
      titulo: 'Nuestra Misión',
      descripcion: 'Brindar atención veterinaria de excelencia en la comodidad del hogar, garantizando el bienestar integral de las mascotas y la tranquilidad de sus familias mediante servicios profesionales, confiables y llenos de amor.',
      icono: <FavoriteIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Nuestra Visión',
      descripcion: 'Ser la veterinaria a domicilio de referencia en la región, reconocida por la calidad humana y profesional de nuestros servicios, contribuyendo al fortalecimiento del vínculo entre las familias y sus mascotas.',
      icono: <StarIcon fontSize="large" sx={{ color: '#c46494' }} />
    }
  ];

  const valores = [
    {
      titulo: 'Empatía',
      descripcion: 'Comprendemos el vínculo especial entre las mascotas y sus familias.',
      icono: <FavoriteIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Profesionalismo',
      descripcion: 'Servicios de la más alta calidad con personal altamente capacitado.',
      icono: <SchoolIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Compromiso',
      descripcion: 'Dedicación absoluta al bienestar y salud de cada mascota.',
      icono: <VerifiedIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Confianza',
      descripcion: 'Transparencia y honestidad en cada diagnóstico y tratamiento.',
      icono: <GroupsIcon fontSize="large" sx={{ color: '#c46494' }} />
    }
  ];

  // Los datos de pacientes ahora se cargan dinámicamente desde Firebase
  // en lugar de usar datos estáticos

  const porQueElegimos = [
    {
      titulo: 'Reducción del Estrés',
      descripcion: 'Las mascotas se sienten más cómodas en su entorno familiar, lo que facilita el examen y reduce la ansiedad tanto del animal como del propietario.',
      icono: <PetsIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Atención Personalizada',
      descripcion: 'Cada consulta es única. Dedicamos el tiempo necesario sin las limitaciones de una clínica tradicional, enfocándonos 100% en tu mascota.',
      icono: <FavoriteIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Comodidad Total',
      descripcion: 'Eliminamos la necesidad de transportar a tu mascota, especialmente beneficioso para animales de edad avanzada, enfermos o de gran tamaño.',
      icono: <FlightIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Prevención de Contagios',
      descripcion: 'Evitamos la exposición a enfermedades infecciosas que pueden transmitirse en salas de espera y consultorios.',
      icono: <HealthIcon fontSize="large" sx={{ color: '#c46494' }} />
    }
  ];

  return (
    <Box>
      {/* Header/Navbar */}
      <AppBar 
        position="fixed" 
        sx={{ 
          backgroundColor: scrolled ? '#fcdcf4' : 'transparent',
          backdropFilter: scrolled ? 'blur(10px)' : 'none',
          boxShadow: scrolled ? '0 2px 10px rgba(0,0,0,0.1)' : 'none',
          zIndex: 1100,
          transition: 'all 0.3s ease'
        }}
      >
        <Toolbar sx={{ py: { xs: 0.5, sm: 1 }, px: { xs: 1, sm: 2 } }}>
          <Box 
            sx={{ 
              mr: { xs: 1, sm: 2, md: 4 }, 
              display: 'flex', 
              alignItems: 'center',
              cursor: 'pointer',
              flexShrink: 0
            }}
            onClick={() => navigate('/')}
          >
            <img 
              src="/logo.png" 
              alt="Belkysvet Logo" 
              style={{ 
                height: window.innerWidth < 600 ? '40px' : window.innerWidth < 900 ? '50px' : '60px', 
                width: 'auto',
                maxWidth: window.innerWidth < 600 ? '100px' : '200px',
                marginRight: window.innerWidth < 600 ? '4px' : '8px'
              }} 
            />
            <Typography 
              variant="h5" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem' },
                display: { xs: 'none', sm: 'block' },
                textShadow: scrolled ? 'none' : '2px 2px 4px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
            >
              belkysveterinaria
            </Typography>
          </Box>
          
          {/* Spacer para empujar los botones a la derecha en móvil */}
          <Box sx={{ flexGrow: 1 }} />
          
          {/* Menú de navegación para desktop */}
          <Box sx={{ 
            display: { xs: 'none', md: 'flex' }, 
            gap: { md: 2, lg: 4 },
            mr: 2
          }}>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate('/')}
            >
              Inicio
            </Button>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate('/servicios')}
            >
              Servicios
            </Button>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)',
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
            >
              Nosotros
            </Button>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate('/petshop')}
            >
              Petshop
            </Button>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate('/contactos')}
            >
              Contacto
            </Button>
          </Box>

          {/* Botón de menú móvil */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              color="inherit"
              aria-label="menu"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              sx={{ 
                color: scrolled ? '#602442' : 'white',
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                transition: 'all 0.3s ease'
              }}
            >
              {mobileMenuOpen ? <ExpandLessIcon /> : <MenuIcon />}
            </IconButton>
          </Box>
        </Toolbar>

        {/* Menú móvil desplegable */}
        <Collapse in={mobileMenuOpen}>
          <Box sx={{ 
            backgroundColor: 'rgba(252, 220, 244, 0.98)',
            borderTop: '1px solid rgba(96, 36, 66, 0.1)',
            py: 1
          }}>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                '&:hover': { backgroundColor: 'rgba(96, 36, 66, 0.1)' }
              }}
              onClick={() => {
                navigate('/');
                setMobileMenuOpen(false);
              }}
            >
              <HomeIcon sx={{ mr: 2 }} />
              Inicio
            </Button>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                '&:hover': { backgroundColor: 'rgba(96, 36, 66, 0.1)' }
              }}
              onClick={() => {
                navigate('/servicios');
                setMobileMenuOpen(false);
              }}
            >
              <MedicalIcon sx={{ mr: 2 }} />
              Servicios
            </Button>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                backgroundColor: 'rgba(96, 36, 66, 0.1)'
              }}
            >
              <InfoIcon sx={{ mr: 2 }} />
              Nosotros
            </Button>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                '&:hover': { backgroundColor: 'rgba(96, 36, 66, 0.1)' }
              }}
              onClick={() => {
                navigate('/petshop');
                setMobileMenuOpen(false);
              }}
            >
              <PetshopIcon sx={{ mr: 2 }} />
              Petshop
            </Button>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                '&:hover': { backgroundColor: 'rgba(96, 36, 66, 0.1)' }
              }}
              onClick={() => {
                navigate('/contactos');
                setMobileMenuOpen(false);
              }}
            >
              <ContactIcon sx={{ mr: 2 }} />
              Contactos
            </Button>
          </Box>
        </Collapse>
      </AppBar>

      {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: {
            xs: 'linear-gradient(rgba(196, 100, 148, 0.8), rgba(96, 36, 66, 0.8)), url("/nosotros.jpg")',
            md: 'linear-gradient(rgba(196, 100, 148, 0.7), rgba(96, 36, 66, 0.7)), url("/nosotros.jpg")'
          },
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: { xs: 'scroll', md: 'fixed' },
          color: 'white',
          py: { xs: 6, sm: 8, md: 10 },
          px: { xs: 2, sm: 3 },
          textAlign: 'center',
          minHeight: { xs: '50vh', sm: '60vh', md: '60vh' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pt: { xs: '80px', sm: '90px', md: '100px' }
        }}
      >
        <Container maxWidth="md">
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom 
            fontWeight="bold"
            sx={{ 
              textShadow: '3px 3px 6px rgba(0,0,0,0.8)',
              fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3.5rem' },
              lineHeight: { xs: 1.2, sm: 1.3, md: 1.4 },
              mb: { xs: 2, sm: 3, md: 4 }
            }}
          >
            Conoce Belkysveterinaria
          </Typography>
          <Typography 
            variant="h5" 
            sx={{ 
              mb: { xs: 3, sm: 4, md: 4 }, 
              opacity: 0.95,
              textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
              fontSize: { xs: '1rem', sm: '1.3rem', md: '1.5rem' },
              lineHeight: { xs: 1.4, sm: 1.5, md: 1.6 },
              px: { xs: 1, sm: 2 }
            }}
          >
            Más que una clínica veterinaria, somos una familia comprometida con el bienestar de tu mascota
          </Typography>
        </Container>
      </Box>

      {/* Misión y Visión */}
      <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 3 } }}>
        <Typography 
          variant="h3" 
          align="center" 
          gutterBottom 
          sx={{ 
            color: '#602442',
            fontSize: { xs: '1.8rem', sm: '2.2rem', md: '3rem' },
            mb: { xs: 2, sm: 3, md: 4 }
          }} 
          fontWeight="bold"
        >
          Nuestra Misión y Visión
        </Typography>
        <Typography 
          variant="h6" 
          align="center" 
          sx={{ 
            color: '#a55e88', 
            mb: { xs: 4, sm: 5, md: 6 },
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
            px: { xs: 1, sm: 2 }
          }}
        >
          Los pilares que guían nuestro compromiso diario
        </Typography>
        
        <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} justifyContent="center">
          {misionVision.map((item, index) => (
            <Grid item xs={12} md={6} key={index} sx={{ display: 'flex' }}>
              <Card 
                sx={{ 
                  height: '100%', 
                  width: '100%',
                  textAlign: 'center',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': { 
                    transform: { xs: 'none', sm: 'translateY(-5px)' },
                    boxShadow: { xs: 3, sm: 6 }
                  },
                  border: '2px solid #fcdcf4',
                  maxWidth: '500px',
                  mx: 'auto'
                }}
              >
                <CardContent sx={{ 
                  p: { xs: 2, sm: 3, md: 4 }, 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column' 
                }}>
                  <Box sx={{ mb: { xs: 2, sm: 3 } }}>
                    {item.icono}
                  </Box>
                  <Typography 
                    variant="h4" 
                    gutterBottom 
                    fontWeight="bold" 
                    sx={{ 
                      color: '#602442', 
                      mb: { xs: 2, sm: 3 }, 
                      minHeight: { xs: 'auto', sm: '4rem' }, 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.125rem' }
                    }}
                  >
                    {item.titulo}
                  </Typography>
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      color: '#602442', 
                      lineHeight: 1.7, 
                      textAlign: 'justify', 
                      flex: 1, 
                      display: 'flex', 
                      alignItems: 'center',
                      fontSize: { xs: '0.95rem', sm: '1rem' }
                    }}
                  >
                    {item.descripcion}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Por qué elegimos la atención a domicilio */}
      <Box sx={{ backgroundColor: '#fcdcf4', py: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 3 } }}>
        <Container maxWidth="lg">
          <Typography 
            variant="h3" 
            align="center" 
            gutterBottom 
            sx={{ 
              color: '#602442',
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '3rem' },
              mb: { xs: 2, sm: 3, md: 4 }
            }} 
            fontWeight="bold"
          >
            ¿Por qué elegimos la atención a domicilio?
          </Typography>
          <Typography 
            variant="h6" 
            align="center" 
            sx={{ 
              color: '#a55e88', 
              mb: { xs: 4, sm: 5, md: 6 },
              fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
              px: { xs: 1, sm: 2 }
            }}
          >
            Nuestro compromiso con una experiencia veterinaria diferente
          </Typography>
          
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} justifyContent="center">
            {porQueElegimos.map((razon, index) => (
              <Grid item xs={12} sm={6} md={3} key={index} sx={{ display: 'flex' }}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    width: '100%',
                    textAlign: 'center',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': { 
                      transform: { xs: 'none', sm: 'translateY(-5px)' },
                      boxShadow: { xs: 3, sm: 6 }
                    },
                    backgroundColor: 'white',
                    maxWidth: '280px',
                    mx: 'auto'
                  }}
                >
                  <CardContent sx={{ 
                    p: { xs: 2, sm: 3 }, 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column' 
                  }}>
                    <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
                      {razon.icono}
                    </Box>
                    <Typography 
                      variant="h6" 
                      gutterBottom 
                      fontWeight="bold" 
                      sx={{ 
                        color: '#602442', 
                        mb: { xs: 1, sm: 2 }, 
                        minHeight: { xs: 'auto', sm: '3rem' }, 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        fontSize: { xs: '1.1rem', sm: '1.25rem' }
                      }}
                    >
                      {razon.titulo}
                    </Typography>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: '#602442', 
                        lineHeight: 1.6, 
                        flex: 1, 
                        display: 'flex', 
                        alignItems: 'center', 
                        textAlign: 'center',
                        fontSize: { xs: '0.9rem', sm: '1rem' }
                      }}
                    >
                      {razon.descripcion}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Nuestros Valores */}
      <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 3 } }}>
        <Typography 
          variant="h3" 
          align="center" 
          gutterBottom 
          sx={{ 
            color: '#602442',
            fontSize: { xs: '1.8rem', sm: '2.2rem', md: '3rem' },
            mb: { xs: 2, sm: 3, md: 4 }
          }} 
          fontWeight="bold"
        >
          Nuestros Valores
        </Typography>
        <Typography 
          variant="h6" 
          align="center" 
          sx={{ 
            color: '#a55e88', 
            mb: { xs: 4, sm: 5, md: 6 },
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
            px: { xs: 1, sm: 2 }
          }}
        >
          Los principios que definen nuestra forma de trabajar
        </Typography>
        
        <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} justifyContent="center">
          {valores.map((valor, index) => (
            <Grid item xs={12} sm={6} md={3} key={index} sx={{ display: 'flex' }}>
              <Card 
                sx={{ 
                  height: '100%', 
                  width: '100%',
                  textAlign: 'center',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': { 
                    transform: { xs: 'none', sm: 'translateY(-5px)' },
                    boxShadow: { xs: 3, sm: 6 }
                  },
                  border: '1px solid #fcdcf4',
                  maxWidth: '280px',
                  mx: 'auto'
                }}
              >
                <CardContent sx={{ 
                  p: { xs: 2, sm: 3 }, 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column' 
                }}>
                  <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
                    {valor.icono}
                  </Box>
                  <Typography 
                    variant="h6" 
                    gutterBottom 
                    fontWeight="bold" 
                    sx={{ 
                      color: '#602442', 
                      mb: { xs: 1, sm: 2 }, 
                      minHeight: { xs: 'auto', sm: '3rem' }, 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      fontSize: { xs: '1.1rem', sm: '1.25rem' }
                    }}
                  >
                    {valor.titulo}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: '#602442', 
                      lineHeight: 1.6, 
                      flex: 1, 
                      display: 'flex', 
                      alignItems: 'center', 
                      textAlign: 'center',
                      fontSize: { xs: '0.9rem', sm: '1rem' }
                    }}
                  >
                    {valor.descripcion}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Nuestro Equipo */}
      <Box sx={{ backgroundColor: '#fcdcf4', py: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 3 } }}>
        <Container maxWidth="lg">
          <Typography 
            variant="h3" 
            align="center" 
            gutterBottom 
            sx={{ 
              color: '#602442',
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '3rem' },
              mb: { xs: 2, sm: 3, md: 4 }
            }} 
            fontWeight="bold"
          >
            Nuestro Equipo
          </Typography>
          <Typography 
            variant="h6" 
            align="center" 
            sx={{ 
              color: '#602442', 
              mb: { xs: 4, sm: 5, md: 6 },
              fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
              px: { xs: 1, sm: 2 }
            }}
          >
            Profesional apasionada por el cuidado animal
          </Typography>
          
          <Grid container spacing={{ xs: 3, sm: 5, md: 6 }} alignItems="center" justifyContent="center">
            <Grid item xs={12} sm={5} md={5} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Box 
                component="img"
                src="/drbelkys.jpg"
                alt="Dra. Belkys Hernández"
                sx={{
                  width: '100%',
                  maxWidth: { xs: '250px', sm: '300px', md: '350px' },
                  height: 'auto',
                  borderRadius: '10px',
                  boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                  border: '4px solid white'
                }}
              />
            </Grid>
            <Grid item xs={12} sm={7} md={7}>
              <Card 
                sx={{ 
                  height: '100%', 
                  width: '100%',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': { 
                    boxShadow: 6
                  },
                  backgroundColor: 'white',
                }}
              >
                <CardContent sx={{ 
                  p: { xs: 3, sm: 4 }, 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column' 
                }}>
                  <Typography 
                    variant="h4" 
                    gutterBottom 
                    fontWeight="bold" 
                    sx={{ 
                      color: '#602442', 
                      mb: 1,
                      fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.2rem' }
                    }}
                  >
                    Dra. Belkys Hernández
                  </Typography>
                  <Typography 
                    variant="subtitle1" 
                    sx={{ 
                      color: '#a55e88', 
                      fontWeight: 'bold', 
                      mb: 1,
                      fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' }
                    }}
                  >
                    Medicina Veterinaria General
                  </Typography>
                  <Typography 
                    variant="subtitle2" 
                    sx={{ 
                      color: '#c46494', 
                      fontWeight: 'bold', 
                      mb: { xs: 2, sm: 3 },
                      fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                    }}
                  >
                    4+ años de experiencia
                  </Typography>
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      color: '#602442', 
                      lineHeight: 1.8, 
                      fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                      mb: 2
                    }}
                  >
                    Apasionada por el bienestar animal y la atención personalizada a domicilio. Fundadora de Belkysveterinaria con una visión innovadora del cuidado veterinario.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Nuestros Pacientes */}
      <Box sx={{ backgroundColor: '#fcdcf4', py: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 3 } }}>
        <Container maxWidth="lg">
          <Typography 
            variant="h3" 
            align="center" 
            gutterBottom 
            sx={{ 
              color: '#602442',
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '3rem' },
              mb: { xs: 2, sm: 3, md: 4 }
            }} 
            fontWeight="bold"
          >
            Nuestros Pacientes
          </Typography>
          <Typography 
            variant="h6" 
            align="center" 
            sx={{ 
              color: '#a55e88', 
              mb: { xs: 4, sm: 5, md: 6 },
              fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
              px: { xs: 1, sm: 2 }
            }}
          >
            Algunos de los animales que hemos tenido el privilegio de atender
          </Typography>
          
          {loadingPacientes ? (
            // Estado de carga
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '350px',
              mb: 4
            }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#a55e88',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2
                }}
              >
                🔄 Cargando nuestros pacientes...
              </Typography>
            </Box>
          ) : pacientesActivos.length > 0 ? (
            // Mostrar pacientes cargados dinámicamente
            <Box sx={{ width: '100%', overflow: 'hidden', position: 'relative', mb: 4 }}>
              <Box sx={{ height: '350px' }}>
                <RollingGallery 
                  images={pacientesActivos.map(p => p.imagen)}
                  pets={pacientesActivos}
                  speed={0.8} 
                  direction="left" 
                  height="350px" 
                />
              </Box>
              <Typography 
                variant="body2" 
                align="center" 
                sx={{ 
                  color: '#a55e88', 
                  mt: 2,
                  fontSize: { xs: '0.8rem', sm: '0.9rem' },
                  fontStyle: 'italic'
                }}
              >
                Mostrando {pacientesActivos.length} de nuestros pacientes activos
              </Typography>
            </Box>
          ) : (
            // Estado cuando no hay pacientes con foto
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column',
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '200px',
              mb: 4,
              textAlign: 'center'
            }}>
              <PetsIcon sx={{ fontSize: '4rem', color: '#c46494', mb: 2 }} />
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#a55e88',
                  mb: 1
                }}
              >
                Pronto mostraremos aquí a nuestros pacientes
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#8a6581',
                  px: 2
                }}
              >
                Estamos actualizando la galería con las fotos de nuestras mascotas atendidas
              </Typography>
            </Box>
          )}
        </Container>
      </Box>

      {/* Llamada a la acción */}
      <Box sx={{ backgroundColor: '#fcdcf4', py: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 3 } }}>
        <Container maxWidth="md" sx={{ textAlign: 'center' }}>
          <Typography 
            variant="h3" 
            gutterBottom 
            sx={{ 
              color: '#602442',
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '3rem' },
              mb: { xs: 2, sm: 3, md: 4 }
            }} 
            fontWeight="bold"
          >
            ¿Quieres conocer más sobre nosotros?
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              color: '#602442', 
              mb: { xs: 3, sm: 4, md: 4 },
              fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
              px: { xs: 1, sm: 2 }
            }}
          >
            Contáctanos para agendar una consulta y conocer nuestros servicios
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 2, sm: 3 }, 
            justifyContent: 'center', 
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center'
          }}>
            <Button
              variant="contained"
              size="large"
              sx={{ 
                backgroundColor: '#602442', 
                '&:hover': { backgroundColor: '#a55e88' },
                px: { xs: 3, sm: 4 },
                py: { xs: 1.5, sm: 2 },
                borderRadius: 3,
                fontSize: { xs: '1rem', sm: '1.1rem' },
                fontWeight: 'bold',
                width: { xs: '100%', sm: 'auto' },
                maxWidth: { xs: '300px', sm: 'none' }
              }}
              startIcon={<WhatsAppIcon />}
              href="https://wa.me/3148355513?text=Hola,%20me%20gustaría%20agendar%20una%20cita"
              target="_blank"
            >
              Contáctanos
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{ 
                borderColor: '#602442', 
                color: '#602442',
                '&:hover': { 
                  backgroundColor: '#602442',
                  color: 'white'
                },
                px: { xs: 3, sm: 4 },
                py: { xs: 1.5, sm: 2 },
                borderRadius: 3,
                fontSize: { xs: '1rem', sm: '1.1rem' },
                fontWeight: 'bold',
                borderWidth: 2,
                width: { xs: '100%', sm: 'auto' },
                maxWidth: { xs: '300px', sm: 'none' }
              }}
              onClick={() => navigate('/servicios')}
            >
              Ver Servicios
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Footer simplificado */}
      <Box sx={{ backgroundColor: '#602442', color: 'white', py: { xs: 3, sm: 4 }, px: { xs: 2, sm: 3 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                mb: { xs: 1, sm: 2 },
                flexDirection: { xs: 'column', sm: 'row' },
                textAlign: { xs: 'center', sm: 'left' }
              }}>
                <img 
                  src="/logo192.png" 
                  alt="Belkysvet Logo" 
                  style={{ 
                    height: window.innerWidth < 600 ? '60px' : '80px', 
                    width: 'auto',
                    marginRight: window.innerWidth < 600 ? '0' : '20px',
                    marginBottom: window.innerWidth < 600 ? '10px' : '0'
                  }} 
                />
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center',
                  textAlign: { xs: 'center', sm: 'left' }
                }}>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      color: '#c46494', 
                      mb: 1, 
                      fontWeight: 'bold',
                      fontSize: { xs: '1.2rem', sm: '1.25rem' }
                    }}
                  >
                    Belkysveterinaria
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      mb: 0, 
                      lineHeight: 1.4,
                      fontSize: { xs: '0.9rem', sm: '1rem' }
                    }}
                  >
                    Atención veterinaria profesional en la comodidad de tu hogar
                  </Typography>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    mt: 1.5,
                    justifyContent: { xs: 'center', sm: 'flex-start' }
                  }}>
                    <LocationIcon sx={{ 
                      fontSize: { xs: '1rem', sm: '1.1rem' }, 
                      color: '#c46494',
                      mr: 0.5 
                    }} />
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        fontSize: { xs: '0.85rem', sm: '0.875rem' },
                        color: '#fcdcf4',
                        fontWeight: '500'
                      }}
                    >
                      Servicio a domicilio - Popayán, Cauca
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: { xs: 'center', md: 'flex-end' },
                justifyContent: 'center',
                height: '100%',
                textAlign: { xs: 'center', md: 'right' }
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  mb: 1,
                  justifyContent: { xs: 'center', md: 'flex-end' }
                }}>
                  <IconButton
                    component="a"
                    href="https://wa.me/573216103829?text=Hola,%20me%20gustaría%20agendar%20una%20cita"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: '#c46494',
                      '&:hover': {
                        color: '#fcdcf4',
                        transform: 'scale(1.1)'
                      },
                      transition: 'all 0.3s ease',
                      p: 1
                    }}
                  >
                    <WhatsAppIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.3rem' } }} />
                  </IconButton>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.9rem', sm: '1rem' }, 
                      fontWeight: '500',
                      ml: 1
                    }}
                  >
                    @belkys.veterinaria
                  </Typography>
                </Box>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  justifyContent: { xs: 'center', md: 'flex-end' },
                  mb: 1
                }}>
                  <IconButton
                    component="a"
                    href="mailto:belkys.veterinaria@gmail.com"
                    sx={{
                      color: '#c46494',
                      '&:hover': {
                        color: '#fcdcf4',
                        transform: 'scale(1.1)'
                      },
                      transition: 'all 0.3s ease',
                      p: 1
                    }}
                  >
                    <EmailIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.3rem' } }} />
                  </IconButton>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.9rem', sm: '1rem' }, 
                      fontWeight: '500',
                      ml: 1
                    }}
                  >
                    belkys.veterinaria@gmail.com
                  </Typography>
                </Box>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  justifyContent: { xs: 'center', md: 'flex-end' }
                }}>
                  <IconButton
                    component="a"
                    href="https://www.instagram.com/belkys.veterinaria/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: '#c46494',
                      '&:hover': {
                        color: '#fcdcf4',
                        transform: 'scale(1.1)'
                      },
                      transition: 'all 0.3s ease',
                      p: 1
                    }}
                  >
                    <InstagramIcon sx={{ fontSize: { xs: '1.5rem', sm: '1.8rem' } }} />
                  </IconButton>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.9rem', sm: '1rem' }, 
                      fontWeight: '500',
                      ml: 1
                    }}
                  >
                    @belkys.veterinaria
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ 
            textAlign: 'center', 
            mt: { xs: 2, sm: 3 }, 
            pt: { xs: 2, sm: 3 }, 
            borderTop: '1px solid rgba(255,255,255,0.2)' 
          }}>
            <Typography 
              variant="body2" 
              sx={{ 
                opacity: 0.8,
                fontSize: { xs: '0.8rem', sm: '0.875rem' }
              }}
            >
              © 2025 Belkysveterinaria. Todos los derechos reservados.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Botón flotante de WhatsApp */}
      <Fab
        color="success"
        aria-label="whatsapp"
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 20 },
          right: { xs: 16, sm: 20 },
          backgroundColor: '#c46494',
          '&:hover': { backgroundColor: '#a55e88' },
          width: { xs: 48, sm: 56 },
          height: { xs: 48, sm: 56 },
          zIndex: 1000
        }}
        href="https://wa.me/573216103829?text=Hola,%20me%20gustaría%20agendar%20una%20cita"
        target="_blank"
      >
        <WhatsAppIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
      </Fab>
    </Box>
  );
};

export default Nosotros;
